import { useSetCameraArmedStatus } from '@hakimo-ui/hakimo/data-access';
import { DisarmWindowModal } from '@hakimo-ui/hakimo/feature-shared';
import { CameraDisarmWindow } from '@hakimo-ui/hakimo/types';
import { toast } from '@hakimo-ui/hakimo/util';

interface Props {
  cameraId: string;
  isArmed: boolean;
  timezone: string;
  cameraDisarmWindow?: CameraDisarmWindow;
  onClose: () => void;
  infoMessage: string;
}

export function UpdateArmedStatus({
  cameraId,
  isArmed,
  timezone,
  cameraDisarmWindow,
  onClose,
  infoMessage,
}: Props) {
  const mutation = useSetCameraArmedStatus(cameraId, () => {
    toast('Camera automation updated!', { type: 'success' });
    onClose();
  });

  return (
    <DisarmWindowModal
      onClose={onClose}
      onSubmit={(payload) =>
        mutation.mutate({
          isArmed: payload.discard || payload.armed,
          activation_window_start: payload.startTimestamp,
          activation_window_end: payload.endTimestamp,
        })
      }
      mutation={{
        isLoading: mutation.isLoading,
        error: mutation.error?.message,
      }}
      timezone={cameraDisarmWindow?.timezone || timezone}
      existingWindow={
        cameraDisarmWindow
          ? {
              startTime: cameraDisarmWindow.startTime,
              endTime: cameraDisarmWindow.endTime,
              timezone: cameraDisarmWindow.timezone,
            }
          : undefined
      }
      infoMessage={infoMessage}
      isArmed={isArmed}
    />
  );
}
